/** Cantidad de dígitos del N° de cheque (CMC7: posiciones 12–19). */
export const NRO_CHEQUE_LEN = 8;
export const NRO_CHEQUE_VACIO = '00000000';

/** Solo dígitos, máximo 8 (sin rellenar). */
export function limitarNroCheque(value: string | number | null | undefined): string {
  return String(value ?? '').replace(/\D/g, '').slice(0, NRO_CHEQUE_LEN);
}

/** Siempre 8 dígitos con ceros a la izquierda (vacío → 00000000). */
export function formatNroCheque(value: string | number | null | undefined): string {
  const digits = limitarNroCheque(value);
  if (!digits) return NRO_CHEQUE_VACIO;
  return digits.padStart(NRO_CHEQUE_LEN, '0');
}

export function nroChequeTieneValor(value: string | number | null | undefined): boolean {
  const digits = limitarNroCheque(value);
  if (!digits) return false;
  const n = Number(digits);
  return Number.isFinite(n) && n > 0;
}

/** Para listados: 219 → 00000219; sin valor → '-'. */
export function formatNroChequeVista(value: string | number | null | undefined): string {
  if (!nroChequeTieneValor(value)) return '-';
  return formatNroCheque(value);
}

/** Para Excel / texto: 219 → 00000219; sin valor → ''. */
export function formatNroChequeExcel(value: unknown): string {
  if (value === null || value === undefined || value === '') return '';
  if (!nroChequeTieneValor(value as string | number)) return '';
  return formatNroCheque(value as string | number);
}

/** Alta: el dígito entra a la derecha y el resto corre a la izquierda. */
export function empujarDigitosNroCheque(prev: string, digitsToAdd: string): string {
  const padded = formatNroCheque(prev);
  const add = String(digitsToAdd ?? '').replace(/\D/g, '');
  if (!add) return padded;
  const sig = padded.replace(/^0+/, '');
  const cupo = NRO_CHEQUE_LEN - sig.length;
  if (cupo <= 0) return padded;
  return (padded + add.slice(0, cupo)).slice(-NRO_CHEQUE_LEN);
}

/** Alta: Backspace saca el último dígito ingresado. */
export function borrarDigitoNroCheque(prev: string): string {
  const sig = formatNroCheque(prev).replace(/^0+/, '');
  return (sig.slice(0, -1) || '').padStart(NRO_CHEQUE_LEN, '0');
}
